const DARK_COLOR_THRESHOLD = 150;
const getBrightness = (color) => {
    const parsedColor = parseColor(color);
    if (parsedColor) {
        const { r, g, b } = parsedColor;
        return (r * 299 + g * 587 + b * 114) / 1000;
    }
    return 0;
};
const parseColor = (color, forcedOpacity) => {
    if (!color) {
        return null;
    }
    if (color.includes('rgba')) {
        return parseRgbaColor(color, forcedOpacity);
    }
    if (color.includes('#')) {
        return parseHexColor(color, forcedOpacity);
    }
    if (color.includes('rgb')) {
        return parseRgbColor(color, forcedOpacity);
    }
    return null;
};
const parseRgbColor = (color, forcedOpacity = 1) => {
    const [r, g, b] = color.replace('rgb(', '').replace(')', '').split(',').map(Number);
    return { r, g, b, a: forcedOpacity };
};
const parseHexColor = (hex, forcedOpacity = 1) => {
    const normal = hex.match(/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i);
    if (normal) {
        const [r, g, b] = normal.slice(1).map(e => parseInt(e, 16));
        return { r, g, b, a: forcedOpacity };
    }
    const shorthand = hex.match(/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i);
    if (shorthand) {
        const [r, g, b] = shorthand.slice(1).map(e => 0x11 * parseInt(e, 16));
        return { r, g, b, a: 1 };
    }
    return null;
};
const parseRgbaColor = (rgbaString, forceOpacity) => {
    const match = /^rgba?\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)(\s*,\s*([0-9]+(\.[0-9]+)?))?\s*\)$/i.exec(rgbaString);
    if (match) {
        let opacity = Number(forceOpacity || match[5]);
        if (Object.is(opacity, undefined)) {
            opacity = 1;
        }
        return {
            r: parseInt(match[1], 10),
            g: parseInt(match[2], 10),
            b: parseInt(match[3], 10),
            a: opacity,
        };
    }
    return null;
};
export const colorToRgba = (color, forcedOpacity) => {
    const c = parseColor(color, forcedOpacity);
    if (!c) {
        return null;
    }
    return `rgba(${c.r},${c.g},${c.b},${c.a})`;
};
export const colorToHex = (color) => {
    const c = parseColor(color);
    if (!c) {
        return null;
    }
    const outParts = [c.r.toString(16), c.g.toString(16), c.b.toString(16)].map((part) => part.padStart(2, '0'));
    return '#' + outParts.join('');
};
export const isDarkColor = (color) => (color ? getBrightness(color) < DARK_COLOR_THRESHOLD : false);
//# sourceMappingURL=color.js.map